import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';
import { type } from '@/theme/typography';

interface Props {
  children: ReactNode;
  /** Optional trailing count, rendered in mono like every other numeral. */
  count?: number;
  /** Optional action on the right of the rule — a link or a small button. */
  action?: ReactNode;
  className?: string;
}

/**
 * The signature device (DESIGN.md §3). Every section on every screen is introduced by it, in place
 * of a bold heading — it is what makes screens look like one product.
 */
export function Eyebrow({ children, count, action, className }: Props) {
  return (
    <div className={cn('mb-4 flex items-baseline gap-3 border-b border-rule pb-2', className)}>
      <span className={type.eyebrow}>{children}</span>
      {count !== undefined && (
        <span className={cn(type.numeral, 'text-xs text-ink-500')}>{count}</span>
      )}
      {action && <span className="ml-auto">{action}</span>}
    </div>
  );
}
